import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    /**
     * Thông tin cột
     */
    col: {
      default: null,
      type: Object
    },
    /**
     * Có lock cột không
     */
    isLock: {
      type: Boolean,
      default: false,
    },
    filter: {
      type: Object,
      default: new Object(),
    },
    filterIconClass: {
      type: String,
      default: 'ic-filter-contain',
    },
  },
});
